var modules_034cfbf6 = {"container":"_1lymub7","qrWrapper":"_18p2h8h","titleContainer":"_1jqrzz2","appImg":"_ty9g6m","stub":"_uts7zr"};
import "../../../assets/CzyLIut6.css";

export { modules_034cfbf6 as default };
//# sourceMappingURL=AppBanner.module.less.js.map
